"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getById = getById;
async function getById(orderRepo, id) {
    return await orderRepo.getById(id);
}
